import React, { forwardRef } from 'react';
import Cleave from 'cleave.js/react';
import { useField } from 'formik';

//FormInput mask özelliği performanslı çalışmadığı durumlarda,
//Bu component Telefon ve VKN/TCKN alanları için oluşturulmuştur.

type Props = {
    label?: string;
    name: string;
    maskOptions: object;
    disabled?: boolean;
    placeholder?: string;
    className?: string;
    required?: boolean;
    error?: any;
};

const FormMaskedInput = forwardRef(({ label, maskOptions, ...props }: Props, ref) => {
    const [field, meta] = useField(props);

    return (
        <div className="">
            {label && (
                <div className="flex items-center text-sm mb-1">
                    <label className="block text-contrast-70 whitespace-nowrap cursor-default" htmlFor={props.name}>
                        {label}
                    </label>
                </div>
            )}
            <Cleave
                {...field}
                {...props}
                options={maskOptions}
                className={`border p-2 rounded w-full ${meta.touched && meta.error ? 'border-red-500 text-contrast-90 text-sm  rounded-md-custom  leading-4 h-8 p-2 bg-contrast-10 border-gray-300 mr-2 focus:outline-none w-full' : 'border-b text-contrast-90 text-sm  rounded-md-custom  leading-4 h-8 p-2 bg-contrast-10 border-gray-300 mr-2 focus:outline-none w-full'} ${props.className}`}
                id={props.name}
                placeholder={props.placeholder}
                disabled={props.disabled}
            />
            {meta.touched && meta.error ? (
                <div className="text-red-500 text-sm mt-2">{meta.error}</div>
            ) : null}
        </div>
    );
});

export default FormMaskedInput;
